/*
 view_pugglepay

 pugglepay = {
 "utimestamp": 1458224412998,
 "am": "50",
 "bid": null,
 "paymentMethodId": 23,
 },
 */
import core from '../../common/lib/core.js';
// import validateAmount from '../lib/validate-amount.js';

const elements = {
	/* see 'assembleOnce' below for more details of the elements object content */
	assembled: false,
	wrap: null
};
const userInput = {
	allvalid: false
};
let paymentmethodId = null;

function userInputToSubmitStructure(paymentMethodId) {
	/* This is the structure required by the depositmethod. To not hardcode keys in earlier steps the values are parsed here. */
	return {
		utimestamp: new Date().getTime(),
		paymentMethodId
	};
}

function deleteAllElements() {
	/* The object-property must either contain an element or an array with elements*/
	/* The wrapper is not deleted.*/
	if (elements && elements.assembled) {
		core.deleteElementsInObjectExcept(elements, ['wrap'], 'view_nofields:57');
		elements.assembled = false;
	}
}

export default {
	create() {
		return;
	},
	init(p, id) {
		paymentmethodId = id;
		/*
		 The inputfield for amount is created by view_paymentform, and is persistant for all paymentmethods.
		 The validation may vary, and the formatting into the submitstructure varies between different methods.
		 The inputelement is therefore a read-only property outisde view_paymentform.
		 */
		elements.wrap = core.getElementIfValid(p, 'wrap', 'view_nofields:init');
	},
	update() {
		/* delete previously created paymentforms */
		/* sync which type of states that shall be updated from view.js */
	},
	close() {
		userInput.allvalid = false;
		/* this form contains almost or no own elements to delete */
		deleteAllElements();
		return null;
	},
	evalInput() {
		return userInputToSubmitStructure(paymentmethodId);
	},
	disableAmountInput() {
		return paymentmethodId === '47';
	},
	displayAmountSelector() {
		return paymentmethodId === '47';
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/view-nofields.js